import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const subjectDetailsApi = createAsyncThunk(
    'auth/subjects/details',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.subjectAction(`${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const subjectDetailsSlice = createSlice({
    name: 'subject details',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetsubject: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(subjectDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(subjectDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(subjectDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetsubject } = subjectDetailsSlice.actions;
export const subjectDetailsReducer = subjectDetailsSlice.reducer